import { Theme } from '@constants';

import { Position } from './types';

export const getUnitsForPosition = (position: Position) => {
  // additional cases can be added but
  // we'll most likely stick to topRight
  switch (position) {
    case 'topRight':
      return { top: Theme.px(61), right: Theme.px(84) }; // 84px to account for 6px border on focus (TBD if this will be needed since this isn't focusable except for accessibility?)
    case 'topLeft':
      return { top: Theme.px(61), left: Theme.px(84) };
    case 'none':
      return null;
    // default to topRight position
    default:
      return { top: Theme.px(61), right: Theme.px(84) };
  }
};
